<template>
  <div id="app">
    <div class="video-list">
      <div class="video-cell" v-for="(item,ind) in videoList" :key="ind" @click="openNewWindow(item.detail_url)">
        <div class="video-img-wrap">
          <p>{{ item.title }}</p>
          <img :src="item.image_list[0]" alt="" class="video-cover"/>
          <img src="./assets/play.png" alt="" class="video-btn"/>
        </div>
        <div class="video-msg">
          <div class="video-left-msg">
            <img src="./assets/logo.png" alt=""/>
            <span>{{ item.source }} · {{ item.published_time }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app',
  data(){
    return{
      videoList: []
    }
  },
  components: {
    // HelloWorld
  },
  mounted() {
    this.$axios.get('/wealth/search',{
      params: {
        api_type:34784,
        page_size:30
      }
    }).then(res => {
      if(res.data.code === 0) {
        this.videoList = res.data.data.data_list
      }
    }).catch(err => {
      console.log(err)
    })
  },
  methods:{
    openNewWindow(_url){
      if(_url) {
        window.open(_url)
      }
    },
    jumpApp(){
      // this.Utils.fixJump({id:this.videoId,mode:5});
      // this.Utils.fixJump({id:this.newsId,mode:1});
      var _id = this.videoId
      var _ori = window.location.origin
      var _url=_ori+'/cfbond/detail/VideoDetail.html?video_id='+_id
      var urlParam = 'cfbond://com.cfbond.acfw/applinks?id='+_id+'&mode=5&url='+_url
      if(navigator.userAgent.match(/android/gi)){
        window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.cfbond.acfw&android_schema='+encodeURIComponent(urlParam)
      } else {
        window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.cfbond.acfw&ios_schema='+encodeURIComponent(urlParam)
      }
      // if(navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/gi)){
      //   window.location.href='https://apps.apple.com/cn/app/%E4%B8%AD%E5%9B%BD%E8%B4%A2%E5%AF%8C/id1370729250'
      // } else {
      //   window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.cfbond.cfw'
      // }
    }
  }
}
</script>

<style scoped>
  @import '../../common/style.css';
  .video-list{
    padding:10px 0.3rem;
  }
  .video-cell{
    width:100%;
    margin-bottom:0.34rem;
  }
  .video-cell .video-img-wrap{
    width:100%;
    height:3.88rem;
    position: relative;
  }
  .video-cell .video-img-wrap::before{
    content: '';
    position: absolute;
    width:100%;
    height:1.6rem;
    background-image: linear-gradient(rgba(0,0,0,0.8),rgba(0,0,0,0));
  }
  .video-cell .video-img-wrap img.video-cover{
    width:100%;
    height:100%;
  }
  .video-cell .video-img-wrap img.video-btn{
    position: absolute;
    z-index:3;
    width:0.96rem;
    height:0.96rem;
    top:50%;
    left:50%;
    margin:-0.48rem 0 0 -0.48rem;
  }
  .video-cell .video-img-wrap p{
    position: absolute;
    font-size:0.32rem;
    color:#fff;
    z-index:2;
    margin-top:0.2rem;
    padding:0 0.26rem;
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .video-msg{
    display: flex;
    margin-top:0.16rem;
  }
  .video-left-msg{
    display: flex;
    align-items: center;
  }
  .video-left-msg img{
    width:0.6rem;
    height:0.6rem;
    display: block;
    border-radius: 100%;
    margin-right:0.2rem;
  }

  .video-left-msg span{
    font-size:0.28rem;
    color:#333;
  }
</style>